// Blog.js

import React, { useState } from "react";
import { useParams } from 'react-router-dom';

export default function Blog() {

  const { link } = useParams();

  const BlogContent = React.lazy(() => import(`./blogs/blog-${link}.js`));

  return (
    <section>
      <React.Suspense fallback={<div>Loading...</div>}>
        <BlogContent />
      </React.Suspense>
    </section>
  );

}
